
import { Component, PropSync, Vue, Watch } from 'vue-property-decorator';
import { ScreenDocumentFlat, ScreenPayload, ScreenShot, UNPACKID } from '@/models/screen.model';
import { TNode } from '@/models/treenode.model';

interface Iitem {
  text: string,
  value: string | null
}

@Component
export default class SbScreenStorePanel extends Vue {
  // Les props
  @PropSync('screen') private screenData!: ScreenDocumentFlat | null

  // Les propriétés
  private scrHovered: ScreenDocumentFlat | null = null;
  private loading: boolean = false
  // private items: Iitem[] = []
  private packid: string | null = null
  private size: number = 200

  // Les propriétés calculées
  private get prjId(): string | null {
    const prj = this.$store.state.current.Project
    return prj ? prj._id : null
  }

  private get loadedShots(): ScreenShot[] {
    return this.$store.state.screen.shots;
  }

  private get screens(): ScreenDocumentFlat[] {
    return this.$store.state.screen.screens
  }

  private get items() {
    const treenodes: TNode[] = this.$store.state.screen.tree.items
    const items = treenodes.map<Iitem>(tn => {
      const root = treenodes.find(tr => tr.id === tn.parent)
      const text = root ? `${root.name}/${tn.name}` : tn.name
      return {text, value: tn.id}
    }).sort((a, b) => a.text.localeCompare(b.text))
    return [{text: 'Unpacked screens', value: UNPACKID}, ...items]

  }

  // Les hooks
  public mounted() {
    this.LoadPackTreenode()
  }

  // Les méthodes surveillées
  @Watch('prjId')
  private async LoadPackTreenode() {
    // console.log('LoadPackTreenode')
    if (this.prjId) {
      this.loading = true
      await this.$store.dispatch('screen/loadPacks', this.prjId)
      this.loading = false
    }
  }

  // Les méthodes

  private async loadScreens() {
    // console.log('loadScreens')
    if (this.prjId && this.packid) {
      const payload: ScreenPayload = {
        prjid: this.prjId,
        packid: this.packid === UNPACKID ? null : this.packid,
      }
      await this.$store.dispatch('screen/loadAllScreens',payload)
      this.screens.forEach(s => {
        this.loadOneShot(s)
      })
    }
  }

  private loadOneShot(s: ScreenDocumentFlat) {
    if (s.screenshot && s.screenshot.length) {
      this.loading = true;
      this.$store.dispatch('screen/loadOneShot', s).then(() => {
        this.loading = false;
        // console.log('fin chargement du shot de : ', s.name);
      });
    } else {
      this.loading = false;
    }
  }

  private srcUrl(screen: ScreenDocumentFlat) {
    let ret: string | null = '';
    const idx = this.loadedShots.findIndex((s: ScreenShot) => s.shotid === screen.screenshot);
    if (idx >= 0) {
      ret = this.loadedShots[idx].shoturl;
    }
    // console.log("srcUrl =", ret);
    return ret ? ret : '';
  }

  private isHovered(screen: ScreenDocumentFlat) {
    return this.scrHovered && screen && this.scrHovered._id === screen._id;
  }
}
